import React from 'react';
import { useEffect, useState } from 'react';
import './TruncateText.css';

// Helper function to add button to the last paragraph
const addButtonToLastParagraph = (html: string, buttonText: string): string => {
  // Find the last closing </p> tag
  const lastParagraphEndIndex = html.lastIndexOf('</p>');

  if (lastParagraphEndIndex === -1) {
    // No paragraph tags found, just append the button
    return (
      html +
      ` <span style="white-space: nowrap; cursor: pointer;" class="deepskyBlueText read-more-btn">${buttonText}</span>`
    );
  }

  // Insert the button before the last </p> tag
  const buttonHtml = ` <span style="white-space: nowrap; cursor: pointer;" class="deepskyBlueText read-more-btn">${buttonText}</span>`;
  return (
    html.slice(0, lastParagraphEndIndex) +
    buttonHtml +
    html.slice(lastParagraphEndIndex)
  );
};
type GetTextProps = {
  truncateTextClass?: string;
  text: string;
  textLength: number;
  isMobileDevice: boolean;
  url?: string;
  viewMoreHtml?: string | null;
  viewLessHtml?: string | null;
  isHtml?: boolean;
  whiteBackground?: boolean;
  viewLess?: boolean;
};

const TruncateText = ({
  truncateTextClass = 'truncateTextContainer',
  text,
  isMobileDevice,
  textLength,
  whiteBackground,
  viewMoreHtml,
  viewLessHtml,
  isHtml,
  url = '',
  viewLess = false
}: GetTextProps) => {
  const [readMore, setReadMore] = useState(false);
  useEffect(() => {
    if (text.length > textLength) setReadMore(false);
  }, []);
  const toggleReadMode = () => {
    setReadMore(!readMore);
  };
  return isHtml ? (
    <section
      className={`padding15 whiteBackGroundColor ${
        whiteBackground ? 'truncateTextWhiteBackground' : 'truncateText'
      }`}
    >
      <div>
        {/* Always render the full content, use CSS overflow to control visibility */}
        <div
          className={`${truncateTextClass} ${readMore ? 'expanded' : ''}`}
          dangerouslySetInnerHTML={{
            __html: viewLessHtml || viewMoreHtml || ''
          }}
        />
        <span
          className="readMoreButton deepskyBlueText read-more-btn"
          onClick={toggleReadMode}
        >
          {readMore ? 'Read Less' : 'Read More'}
        </span>
      </div>
    </section>
  ) : (
    <section className="padding15 whiteBackGroundColor">
      {text.length > textLength && isMobileDevice ? (
        <>
          {readMore && <span>{text}</span>}
          {!readMore && <span>{text.substring(0, textLength)}...</span>}
          <span> </span>
          <span>
            <span
              style={{ whiteSpace: 'nowrap' }}
              className={`deepskyBlueText`}
              onClick={toggleReadMode}
            >
              {readMore ? 'Read Less' : 'Read More'}
            </span>
          </span>
        </>
      ) : (
        <>{text}</>
      )}
    </section>
  );
};

const ReadMoreOrLess = (toggleReadMode, readMore) => {
  return (
    <span>
      <span
        style={{ whiteSpace: 'nowrap' }}
        className={`deepskyBlueText`}
        onClick={toggleReadMode}
      >
        {readMore ? 'Read Less' : 'Read More'}
      </span>
    </span>
  );
};
export default TruncateText;
